import Card from 'components/Card/Card';

import './assigmentDetails.scoped.scss';

const STUDY = ({ study }) => {
  return (
    <Card>
      <Card.Header>
        <h4>{study && study.title}</h4>
      </Card.Header>
      <Card.Body>
        {study && (
          // ql-editor class is really important
          <div
            className={'ql-editor p-0'}
            style={{ padding: 0 }}
            dangerouslySetInnerHTML={{
              __html: study.description,
            }}
          />
        )}

        {!study && <h1>Select study</h1>}
      </Card.Body>
    </Card>
  );
};

export default STUDY;
